module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-bg"
  }, [_c('div', {
    staticClass: "login-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/login_img.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-box"
  }, [(_vm.handleType == 0 || _vm.handleType == 1) ? _c('div', [_c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "name-pwd",
    class: _vm.handleType == 0 ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.changeHandleType(0)
      }
    }
  }, [_vm._v("用户登录")]), _vm._v(" "), _c('div', {
    staticClass: "register",
    class: _vm.handleType == 1 ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.changeHandleType(1)
      }
    }
  }, [_vm._v("用户注册")])]), _vm._v(" "), (_vm.handleType == 0) ? _c('div', [_c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "11",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phone) ? _c('div', {
    staticClass: "close-btn iconfont icon-guanbi",
    on: {
      "click": _vm.cleanPhone
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [((_vm.showPwd ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pwd) ? _vm._i(_vm.pwd, null) > -1 : (_vm.pwd)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pwd,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pwd = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.pwd = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.pwd = $$c
        }
      }
    }
  }) : ((_vm.showPwd ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.pwd, null)
    },
    on: {
      "change": function($event) {
        _vm.pwd = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码",
      "type": _vm.showPwd ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "eye iconfont",
    class: _vm.showPwd ? 'icon-kai' : 'icon-guan',
    on: {
      "click": _vm.toggleEye
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "handle-btn",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登 录")]), _vm._v(" "), _c('div', {
    staticClass: "ex"
  }, [_c('div', {
    staticClass: "error-info"
  }, [_vm._v(_vm._s(_vm.errMsg))]), _vm._v(" "), _c('div', {
    staticClass: "forget",
    on: {
      "click": function($event) {
        return _vm.changeHandleType(2)
      }
    }
  }, [_vm._v("忘记密码")])])]) : (_vm.handleType == 1) ? _c('div', [_c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "placeholder": "请输入用户名称"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.username) ? _c('div', {
    staticClass: "close-btn iconfont icon-guanbi",
    on: {
      "click": _vm.cleanUsername
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "11",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phone) ? _c('div', {
    staticClass: "close-btn iconfont icon-guanbi",
    on: {
      "click": _vm.cleanPhone
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [((_vm.showPwd ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码（长度>=6）",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pwd) ? _vm._i(_vm.pwd, null) > -1 : (_vm.pwd)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pwd,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pwd = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.pwd = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.pwd = $$c
        }
      }
    }
  }) : ((_vm.showPwd ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码（长度>=6）",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.pwd, null)
    },
    on: {
      "change": function($event) {
        _vm.pwd = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码（长度>=6）",
      "type": _vm.showPwd ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "eye iconfont",
    class: _vm.showPwd ? 'icon-kai' : 'icon-guan',
    on: {
      "click": _vm.toggleEye
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captchaCode),
      expression: "captchaCode"
    }],
    staticClass: "input pwd",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.captchaCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captchaCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "captcha-code",
    on: {
      "click": _vm.getCaptchaCode
    }
  }, [(_vm.timeLeft == 0) ? _c('div', [_vm._v("获取验证码")]) : _c('div', [_vm._v("还剩 " + _vm._s(_vm.timeLeft) + " 秒")])])])]), _vm._v(" "), _c('div', {
    staticClass: "handle-btn",
    on: {
      "click": _vm.register
    }
  }, [_vm._v("注 册")]), _vm._v(" "), _c('div', {
    staticClass: "ex"
  }, [_c('div', {
    staticClass: "error-info"
  }, [_vm._v(_vm._s(_vm.errMsg))]), _vm._v(" "), _c('div', {
    staticClass: "forget",
    on: {
      "click": function($event) {
        return _vm.changeHandleType(2)
      }
    }
  }, [_vm._v("忘记密码")])])]) : _vm._e()]) : _c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "11",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phone) ? _c('div', {
    staticClass: "close-btn iconfont icon-guanbi",
    on: {
      "click": _vm.cleanPhone
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [((_vm.showPwd ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pwd) ? _vm._i(_vm.pwd, null) > -1 : (_vm.pwd)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pwd,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pwd = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.pwd = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.pwd = $$c
        }
      }
    }
  }) : ((_vm.showPwd ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.pwd, null)
    },
    on: {
      "change": function($event) {
        _vm.pwd = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码",
      "type": _vm.showPwd ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "eye iconfont",
    class: _vm.showPwd ? 'icon-kai' : 'icon-guan',
    on: {
      "click": _vm.toggleEye
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captchaCode),
      expression: "captchaCode"
    }],
    staticClass: "input pwd",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.captchaCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captchaCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "captcha-code",
    on: {
      "click": _vm.getCaptchaCode
    }
  }, [(_vm.timeLeft == 0) ? _c('div', [_vm._v("获取验证码")]) : _c('div', [_vm._v("还剩 " + _vm._s(_vm.timeLeft) + " 秒")])])])]), _vm._v(" "), _c('div', {
    staticClass: "handle-btn",
    on: {
      "click": _vm.changePwd
    }
  }, [_vm._v("修 改")]), _vm._v(" "), _c('div', {
    staticClass: "ex"
  }, [_c('div', {
    staticClass: "error-info"
  }, [_vm._v(_vm._s(_vm.errMsg))]), _vm._v(" "), _c('div', {
    staticClass: "forget",
    on: {
      "click": function($event) {
        return _vm.changeHandleType(0)
      }
    }
  }, [_vm._v("用户登录")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "active"
  }, [_vm._v("找回密码")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43708773"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = 333
// module chunks = 1